module.exports = __webpack_public_path__ + "assets/img/driver-btn-aa7a38a0.png";